import { render, staticRenderFns } from "./RaceListSection.vue?vue&type=template&id=bd101d9a&scoped=true"
import script from "./RaceListSection.vue?vue&type=script&lang=ts"
export * from "./RaceListSection.vue?vue&type=script&lang=ts"
import style0 from "./RaceListSection.vue?vue&type=style&index=0&id=bd101d9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd101d9a",
  null
  
)

export default component.exports